import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import {
  closeModal,
  openModal,
  toggleOffCanvas
} from '../../common/actions/layout'
import { getUser, getUserProfile } from '../../common/actions/user/'
import {
  getUserVideoPlayerStatus,
  initClientUserSearchResultsViewType
} from '../../common/actions/user/preference'

import { getSessionSuccessAction } from '../../common/actions/user/session'
import { IRootState } from '../../common/reducers'

import { IBannerApiData } from '../../common/actions/marketing/banner'

interface IOwnProps extends RouteConfigComponentProps<any> {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
}

interface IStateProps {
  banners: IBannerApiData[]
  baseUrl: string
  currentSite: string
  errorPage: any
  experiments: any
  ingestedContent: any
  isModalOpen: any
  menuConfig: any
  noIndex: any
  openModalData: any
  openModalType: any
  seoMeta: any
  stats: any
  user: any
  clientFinishedLoading: boolean
  clientVersion: number
}

interface IDispatchProps {
  closeModal: () => any
  handleSignInSuccess: (token: string) => any
  initUser: () => void
  openModal: (data: any) => any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { layout, common, searchPage, user, marketing, experiments } = state
  const { isModalOpen, openModalType, openModalData } = layout
  const { ingestedContent } = searchPage
  const { banners } = marketing

  return {
    banners,
    baseUrl: common.baseUrl,
    currentSite: common.currentSite,
    errorPage: common.errorPage,
    experiments,
    ingestedContent,
    isModalOpen,
    menuConfig: common.menuConfig,
    noIndex: common.noIndex,
    openModalData,
    openModalType,
    seoMeta: common.seoMeta,
    stats: common.stats,
    clientFinishedLoading: common.clientFinishedLoading,
    clientVersion: common.clientVersion,
    user
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IRootState>,
  ownProps: IOwnProps
): IDispatchProps => {
  return {
    closeModal: () => dispatch(closeModal()),
    handleSignInSuccess: (token: string) => {
      dispatch(getSessionSuccessAction(token))
      return dispatch(getUserProfile(token) as any)
    },
    initUser: () => {
      dispatch(initClientUserSearchResultsViewType(ownProps.location) as any)
      dispatch(getUserVideoPlayerStatus())
      dispatch(getUser() as any)
    },
    openModal: (data: any) => dispatch(openModal(data))
  }
}

export type Props = IOwnProps & IDispatchProps & IStateProps

const createAppContainer = (component: React.ComponentType<Props>) => {
  return connect<IStateProps, IDispatchProps, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(component)
}

export default createAppContainer



// WEBPACK FOOTER //
// ./client/containers/appContainer.ts